package fr.xibalba.generateurClassesLycee

typealias Triple<T> = kotlin.Triple<T, T, T>
typealias Pair<T> = kotlin.Pair<T, T>
fun <T> List<T>.mapToTriple(): Triple<T> {
    if (this.size != 3) throw IllegalArgumentException("List must contain exactly 3 elements")
    return Triple(this[0], this[1], this[2])
}
fun <T> List<T>.mapToPair(): Pair<T> {
    if (this.size != 2) throw IllegalArgumentException("List must contain exactly 2 elements")
    return Pair(this[0], this[1])
}
fun <T> List<T>.expectUpToOne(): List<T> {
    if (this.size > 1) throw IllegalArgumentException("List must contain at most one element")
    return this
}
typealias Condition<T> = (T) -> Boolean